import React, { useContext } from 'react';
import classNames from 'classnames';
import { RootContext } from '../context';

import styles from './VocationSelector.module.css';

const VOCATIONS: Vocation[] = [ 'knight', 'druid', 'paladin', 'sorcerer', 'monk' ];

export const VocationSelector: React.FC = () => {
  const { vocation, setVocation, level, setLevel } = useContext(RootContext);

  function onLevelChange(e: React.ChangeEvent<HTMLInputElement>) {
    const value = e.target.value;
    if (value === '') {
      setLevel(0);
      return;
    }

    const intValue = parseInt(value);
    if (value === intValue.toString() && intValue > 0) {
      setLevel(intValue);
    }
  }

  return <>
    <span style={{padding: '2px'}}>Character Information</span>
    <div className={styles.vocationSelector}>
      { VOCATIONS.map((voc) => <button
        key={voc}
        className={classNames(voc === vocation && styles.active)}
        onClick={() => setVocation(voc)}>
          { voc }
      </button>) }
    </div>
    <input placeholder="level" value={level || ''} onChange={onLevelChange}/>
  </>;
}
